import { render, staticRenderFns } from "./MarketToday.vue?vue&type=template&id=b1f1d600&scoped=true"
import script from "./MarketToday.vue?vue&type=script&lang=ts"
export * from "./MarketToday.vue?vue&type=script&lang=ts"
import style0 from "./MarketToday.vue?vue&type=style&index=0&id=b1f1d600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f1d600",
  null
  
)

export default component.exports